import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { VOICES } from './data';

/** 시안 "현장에서 자주 듣는 이야기" — 질문 3개와 답변 카드 */
const Voices = () => (
  <section className={`${p.section} ${p.sectionWide} ${p.reveal}`}>
    <div className={p.headCenter}>
      <div className={p.badge}>WHY OFFER GROUP</div>
      <h2 className={p.title}>
        현장에서 자주 듣는 이야기,
        <br />
        오퍼그룹은 이렇게 답합니다.
      </h2>
    </div>

    <div className={p.voiceGrid}>
      {VOICES.map(({ quote, answer }) => (
        <div className={`${p.card} ${p.voiceCard}`} key={quote}>
          <div className={p.quoteBox}>{quote}</div>
          <p className={p.voiceAnswer}>
            {answer[0]}
            <strong className={p.em}>{answer[1]}</strong>
            {answer[2]}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default Voices;
